module.exports = __webpack_public_path__ + "img/04-B06.9361adba.png";